import {forwardRef} from 'react'

import {twMerge} from '@sdox/utils'

import type {ComponentProps} from 'react'

export const RangeInput = forwardRef<HTMLInputElement, ComponentProps<'input'>>(({className, ...restProps}, ref) => (
  <input
    type={'range'}
    ref={ref}
    className={twMerge('custom-slider-thumb pointer-events-none absolute h-0 w-full outline-none', className)}
    {...restProps}
  />
))

RangeInput.displayName = 'RangeInput'
